const HexagonExclamationIcon = ({ active }) => {
  const fillColor = active ? "#1E1E1E" : "#969696";
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_217_5861)">
        <path
          d="M13.615 5.52967L11.5733 2.02967C11.0524 1.13717 10.0876 0.583008 9.05391 0.583008H4.92858C3.8955 0.583008 2.93008 1.13717 2.40916 2.02967L0.36808 5.52967C-0.161003 6.43617 -0.161003 7.56259 0.36808 8.46909L2.40975 11.9691C2.93066 12.8616 3.8955 13.4158 4.92916 13.4158H9.0545C10.0876 13.4158 11.053 12.8616 11.5739 11.9691L13.6156 8.46909C14.1447 7.56259 14.1441 6.43617 13.615 5.52967ZM12.607 7.88109L10.5653 11.3811C10.2527 11.9166 9.674 12.2491 9.05391 12.2491H4.92858C4.3085 12.2491 3.72925 11.9166 3.41716 11.3811L1.3755 7.88109C1.05816 7.33684 1.05816 6.66134 1.3755 6.11767L3.41716 2.61767C3.72983 2.08217 4.3085 1.74967 4.92858 1.74967H9.05391C9.674 1.74967 10.2532 2.08217 10.5653 2.61767L12.607 6.11767C12.9243 6.66192 12.9243 7.33742 12.607 7.88109ZM6.41608 7.29076V4.08242C6.41608 3.75984 6.67741 3.49909 6.99941 3.49909C7.32141 3.49909 7.58275 3.75984 7.58275 4.08242V7.29076C7.58275 7.61334 7.32141 7.87409 6.99941 7.87409C6.67741 7.87409 6.41608 7.61334 6.41608 7.29076ZM7.87441 9.62409C7.87441 10.1071 7.48241 10.4991 6.99941 10.4991C6.51641 10.4991 6.12441 10.1071 6.12441 9.62409C6.12441 9.14109 6.51641 8.74909 6.99941 8.74909C7.48241 8.74909 7.87441 9.14109 7.87441 9.62409Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_217_5861">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HexagonExclamationIcon;
